export const DateTimeTokens = {
  // Days
  $D$: 'day',
  $DD$: 'dayPadded',

  // Months
  $M$: 'monthNum',
  $MM$: 'monthNumPadded',
  $MMM$: 'monthAbbr',
  $MMMM$: 'monthFull',

  // Year
  $YY$: 'yearAbbr',
  $YYYY$: 'yearNum',
};
